/**
 * File Name          : battery_state_char.model.ts
 * Author             : Jared Laine Dyreson
 * Version            : 0.0.0
 * Date               : 2026-03-18
 * Description        : Short Description (manual edit required)
 * 
 * Copyright (C) Innovative Design Labs, Inc. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * This file is subject to the terms and conditions defined in
 * file 'IDL_BACKGROUNDTECH_LICENSE.txt', which is part of this source code package.
 */

export enum BLE_CHARGE_ICON
{
    NA = 0,
    CHARGING_LVL_UNKNOWN,
    CHARGING_LVL_VERYLOW,
    CHARGING_LVL_LOW,
    CHARGING_LVL_MED,
    CHARGING_LVL_HIGH,
    CHARGING_LVL_FULL,
    ON_BATTERY_LVL_CRITICAL,
    ON_BATTERY_LVL_VERYLOW,
    ON_BATTERY_LVL_LOW,
    ON_BATTERY_LVL_MED, //0x0A
    ON_BATTERY_LVL_HIGH,
    ON_BATTERY_LVL_FULL,
    NO_BATTERY,
    FAULT
};

export function isChargingState(state: BLE_CHARGE_ICON): boolean {
    return state >= BLE_CHARGE_ICON.CHARGING_LVL_UNKNOWN && state <= BLE_CHARGE_ICON.CHARGING_LVL_FULL;
}

export function bleChargeIconToString(icon: BLE_CHARGE_ICON): string {
    switch (icon) {
        case BLE_CHARGE_ICON.NA:
            return 'N/A';
        case BLE_CHARGE_ICON.CHARGING_LVL_UNKNOWN:
            return 'Charging (unknown)';
        case BLE_CHARGE_ICON.CHARGING_LVL_VERYLOW:
            return 'Charging — very low';
        case BLE_CHARGE_ICON.CHARGING_LVL_LOW:
            return 'Charging — low';
        case BLE_CHARGE_ICON.CHARGING_LVL_MED:
            return 'Charging — medium';
        case BLE_CHARGE_ICON.CHARGING_LVL_HIGH:
            return 'Charging — high';
        case BLE_CHARGE_ICON.CHARGING_LVL_FULL:
            return 'Charging — full';
        case BLE_CHARGE_ICON.ON_BATTERY_LVL_CRITICAL:
            return 'On battery — critical';
        case BLE_CHARGE_ICON.ON_BATTERY_LVL_VERYLOW:
            return 'On battery — very low';
        case BLE_CHARGE_ICON.ON_BATTERY_LVL_LOW:
            return 'On battery — low';
        case BLE_CHARGE_ICON.ON_BATTERY_LVL_MED:
            return 'On battery — medium';
        case BLE_CHARGE_ICON.ON_BATTERY_LVL_HIGH:
            return 'On battery — high';
        case BLE_CHARGE_ICON.ON_BATTERY_LVL_FULL:
            return 'On battery — full';
        case BLE_CHARGE_ICON.NO_BATTERY:
            return 'No battery';
        case BLE_CHARGE_ICON.FAULT:
            return 'Power Fault';
        default:
            return `Power State Unknown (${icon})`;
    }
}
 
export enum BLE_CHARGE_FAULT
{
    NA,
    NONE,
    BAT_UNDERVOLTAGE,
    BAT_OVERCURRENT,
    INPUT_UNDERVOLTAGE,
    INPUT_OVERVOLTAGE,
};